import React from 'react';
import { Box, TextField } from '@mui/material';
import QuestionHelpText from '../QuestionHelpText';
import type { Question } from '../../../types';

interface DateRendererProps {
  question: Question;
  selectedValue: string | undefined;
  onSelect: (value: string) => void;
}

function DateRenderer({ question, selectedValue, onSelect }: DateRendererProps): JSX.Element {
  const panelSx = question.metadata?.showQuestionPanel === false
    ? { mt: 1 }
    : { mt: 1, border: '1px solid', borderColor: 'divider', borderTop: '4px solid', borderTopColor: 'primary.main', borderRadius: 2, p: 3, backgroundColor: 'background.paper' };

  return (
    <Box className="cla-quiz-date" data-quiz-question-id={question.id} sx={panelSx}>
      <QuestionHelpText description={question.metadata?.description} className="cla-quiz-date-description" />
      <TextField
        className="cla-quiz-date-input"
        type="date"
        value={selectedValue ?? ''}
        onChange={(event) => onSelect(event.target.value)}
        required={question.isRequired}
        fullWidth
        inputProps={{ 'aria-label': question.text }}
      />
    </Box>
  );
}

export default DateRenderer;
